import { Col, Divider, Row, Space } from "antd";
import styled from "styled-components";
import colors, { TypeColorNames } from "../../../theme/colors";
import defaultTheme from "../../../theme/theme";
import SocialIcon from "../socialIcon/SocialIcon";

import { useTranslation } from 'react-i18next';

interface StyledFooterProps {
  style?: any;
  color: TypeColorNames;
  image?: any;
  theme?: typeof defaultTheme;
  hasMarginTop?: boolean;
}

interface Social {
  url: string;
  active: boolean;
}

export interface IFooter {
  style?: any;
  color: TypeColorNames;
  image?: any;
  social?: Array<Social>;
  theme?: typeof defaultTheme;
  companyName?: String;
  hasMarginTop?: boolean;
  idForAnchor?: string;
  textColor?: TypeColorNames;
  className?: string;
}

const DEFAULT_COLOR = "darkBackground";

const StyledFooter = styled.div<StyledFooterProps>`
  background-color: ${(props) => props.color};
  text-align: initial;
  border-bottom: 1px solid ${defaultTheme.colors.line};
  padding: 64px 80px 61px 81px;

  @media only screen and (max-width: 768px) {
    padding: 68px 24px 32px 24px;
  }

  .logo {
    img {
      margin-bottom: 15px;
    }
  }

  .socialMedia {
    margin-top: 15px;
    display: flex;
  }
`;

const Footer = ({
  color,
  image,
  social,
  companyName,
  hasMarginTop,
  idForAnchor,
  textColor,
  style,
  className,
}: IFooter) => {

  const {t} = useTranslation();

  return (
    <StyledFooter className={className} style={style} color={color} hasMarginTop={hasMarginTop} id={idForAnchor}>
      <Row justify="space-between">
        <Col className="logo" xs={14} lg={16}>
          <img style={{ width: "140px" }} src={image} alt="logo" />

          <br />
          <span
            color={colors.white}
            style={{ marginRight: "5px", color: textColor || colors.black }}
          >
            {t('PoweredByEventials')}
          </span>
          <a href="https://eventials.com" target="blank">
            <span color="primaryLight" style={{ color: textColor || colors.black }}>
              Eventials
            </span>
          </a>
        </Col>
        {social ? (
          <Col className="socialMedia">
            <Space align="start">
              {Object.keys(social).map((key: any) => (
                <SocialIcon
                  key={social[key].url}
                  href={social[key].url}
                  type={key}
                  color={color}
                  isActive={social[key].active}
                />
              ))}
            </Space>
          </Col>
        ) : null}
      </Row>

      <Row>
        <Divider style={{ backgroundColor: textColor || defaultTheme.colors.body }} />

        <p style={{ color: textColor || colors.black}}>
          © {companyName} {new Date().getFullYear()}. {t('copyright')}
        </p>
      </Row>
    </StyledFooter>
  );
};

Footer.defaultProps = {
  color: DEFAULT_COLOR,
};

export default Footer;
